import { FlexBox } from "@brg/ui";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { LayoutConst } from "core";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    width: 100%;
    background-color: transparent;
    padding-bottom: 120px;
    // padding-top: 56px;
    z-index: 99999;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0px 0 80px 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 0px 10px 40px 10px;
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: 0px 0 40px 0;
    }
`;

export const InfoContainer = styled(FlexBox)`
    max-width: 1152px;
    width: 1152px;
    margin: 0 auto;
    min-height: 132px;
    height: 100%;
    flex-flow: column;

    * {
        margin-left: 0;
    }

    div {
        padding-top: 0;
        margin-top: 0;
        padding-left: 0;
        padding-bottom: 0;
    }

    .action-buttons {
        .context-button {
            max-width: 270px !important;
            width: fit-content !important;
            margin-right: 24px;
        }
    }

    h1 {
        font-size: 51px;
        line-height: 60px;
        margin-bottom: 24px;

        @media (max-width: ${LayoutConst.screen.m}px) {
            font-size: 30px;
            line-height: 33px;
            margin-bottom: 16px;

            a, button {
                margin-right: 16px;
            }
        }

        @media (max-width: ${LayoutConst.screen.s -1 }px) {
            font-size: 28px;
            line-height: 34px;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${LayoutConst.container.m + 'px'}; 
        max-width: ${LayoutConst.container.m + 'px'}; 
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        min-height: 89px;
        width: ${LayoutConst.container.xs + 'px'};
        max-width: ${LayoutConst.container.xs + 'px'};

        .action-buttons {
            flex-direction: row !important;
            justify-content: flex-start;
            flex-wrap: nowrap;

            .context-button {
                max-width: 226px !important;
                width: 226px !important;
                min-width: 226px !important;
                margin: 0 16px 10px 0 !important;
            }
        }
    }

    @media (max-width: 833px) {
        .action-buttons {
            flex-wrap: wrap;

            .context-button {
                min-width: auto !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        .action-buttons {
            a, button {
                margin-right: 16px !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s -1 }px) {
        .action-buttons {
            flex-direction: column !important;
            justify-content: flex-start;
            .context-button {
                width: 100% !important;
                max-width: none !important;
            }

            .context-button {
                margin-bottom: 10px !important;
                min-height: 46px;
            }
        }
    }

`;

export const Title = styled(HSESansTitleCoolEpicMegoGena)`
    font-size: 51px;
    line-height: 60px;

`;import { FlexBox } from "@brg/ui";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { LayoutConst } from "core";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    width: 100%;
    background-color: transparent;
    padding-bottom: 120px;
    // padding-top: 56px;
    z-index: 99999;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0px 0 80px 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 0px 10px 40px 10px;
    }

    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: 0px 0 40px 0;
    }
`;

export const InfoContainer = styled(FlexBox)`
    max-width: 1152px;
    width: 1152px;
    margin: 0 auto;
    min-height: 132px;
    height: 100%;
    flex-flow: column;

    * {
        margin-left: 0;
    }

    div {
        padding-top: 0;
        margin-top: 0;
        padding-left: 0;
        padding-bottom: 0;
    }

    .action-buttons {
        .context-button {
            max-width: 270px !important;
            width: fit-content !important;
            margin-right: 24px;
        }
    }

    h1 {
        font-size: 51px;
        line-height: 60px;
        margin-bottom: 24px;

        @media (max-width: ${LayoutConst.screen.m}px) {
            font-size: 30px;
            line-height: 33px;
            margin-bottom: 16px;

            a, button {
                margin-right: 16px;
            }
        }

        @media (max-width: ${LayoutConst.screen.s -1 }px) {
            font-size: 28px;
            line-height: 34px;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${LayoutConst.container.m + 'px'}; 
        max-width: ${LayoutConst.container.m + 'px'}; 
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        min-height: 89px;
        width: ${LayoutConst.container.xs + 'px'};
        max-width: ${LayoutConst.container.xs + 'px'};

        .action-buttons {
            flex-direction: row !important;
            justify-content: flex-start;
            flex-wrap: nowrap;

            .context-button {
                max-width: 226px !important;
                width: 226px !important;
                min-width: 226px !important;
                margin: 0 16px 10px 0 !important;
            }
        }
    }

    @media (max-width: 833px) {
        .action-buttons {
            flex-wrap: wrap;

            .context-button {
                min-width: auto !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        .action-buttons {
            a, button {
                margin-right: 16px !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s -1 }px) {
        .action-buttons {
            flex-direction: column !important;
            justify-content: flex-start;
            .context-button {
                width: 100% !important;
                max-width: none !important;
            }

            .context-button {
                margin-bottom: 10px !important;
                min-height: 46px;
            }
        }
    }

`;

export const Title = styled(HSESansTitleCoolEpicMegoGena)`
    font-size: 51px;
    line-height: 60px;

`;